var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.bannerUrl?_vm.bannerUrl:_vm.bannerUrlDefault,"alt":"麒麟遨天 携手共测"}})])}
var staticRenderFns = []

export { render, staticRenderFns }